import { ImageBlockSchema } from '@blocksuite/hive-model';
import { SlashMenuConfigExtension } from '@blocksuite/hive-widget-slash-menu';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { ImageBlockAdapterExtensions } from './adapters/extension';
import { imageSlashMenuConfig } from './configs/slash-menu';
import { createBuiltinToolbarConfigExtension } from './configs/toolbar';
import { ImageProxyService } from './image-proxy-service';
import { ImageDropOption } from './image-service';

const flavour = ImageBlockSchema.model.flavour;

export const ImageBlockSpec: ExtensionType[] = [
  FlavourExtension(flavour),
  BlockViewExtension(flavour, model => {
    const parent = model.doc.getParent(model.id);

    if (parent?.flavour === 'hive:surface') {
      return literal`hive-edgeless-image`;
    }

    return literal`hive-image`;
  }),
  ImageDropOption,
  ImageBlockAdapterExtensions,
  createBuiltinToolbarConfigExtension(flavour),
  SlashMenuConfigExtension(flavour, imageSlashMenuConfig),
].flat();

export const ImageStoreSpec: ExtensionType[] = [ImageProxyService];
